import { render } from "./QuizGamePage.vue?vue&type=template&id=1ca4b351&scoped=true"
import script from "./QuizGamePage.vue?vue&type=script&lang=js"
export * from "./QuizGamePage.vue?vue&type=script&lang=js"

import "./QuizGamePage.vue?vue&type=style&index=0&id=1ca4b351&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca4b351"]])

export default __exports__